import { Box, Divider, List, ListItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import EventEHRImageAvatar from "../../component-lib/Atoms/image-avatar/EventEHRImageAvatar";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PushPinIcon from "@mui/icons-material/PushPin";
import EventEHRLazyDropdown from "../../component-lib/Molecules/lazy-loading-search/EventEHRLazyLoadingSearch";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getLazyLoadingApiResponse,
  getLazyLoadingSearchApiResponse,
} from "../../utils/constantsFunctions";
import {
  getGroupCreated,
  postConversationData,
  postGroupCreate,
  postBroadcast,
} from "./messagingSaga";
import { canBroadcastMessage, getLoginUserId } from "../../utils/getToken";
import { plusIcon, searchIcon } from "../../assets";
import GroupChatDialog from "./group-chat/CreateGroupChatDialog";
import BroadcastMessageDialog from "./group-chat/BroadcastMessageDialog";
import Button from "../../component-lib/Molecules/button/Button";
import {
  componentKey,
  setCloseBroadcast,
  setCloseCreateGroup,
} from "./messagingSlice";
import EventEHRToggleTabButton from "../../component-lib/Molecules/toggle-tab-button/EventEHRToggleTabButton";

interface UserListProps {
  conversationList: any;
  selectedProviderMsg: any;
  selectedTabForUser: string;
  onClickUser: (data: any) => void;
  onClickGroup: (data: any) => void;
  handlePinMessage: (isPin: Boolean, messageId: string, id: string) => void;
  handleSetSelectedValue: (data: any) => void;
  setSelectedTab: (data: string) => void;
}

const UsersList = ({
  conversationList,
  selectedProviderMsg,
  selectedTabForUser,
  onClickUser,
  onClickGroup,
  handlePinMessage,
  handleSetSelectedValue,
  setSelectedTab,
}: UserListProps) => {
  const commonTimeStyle = {
    color: "#BCBCBC",
    fontSize: "12px",
    fontWeight: "400",
  };

  const { groupCreated, closeCreateGroup, closeBroadcast } = useSelector(
    (state: any) => state[componentKey]
  );

  const dispatch = useDispatch();
  const parseLoginUserId: any = getLoginUserId();
  const loginUserId = JSON.parse(parseLoginUserId);
  const [openGroupChatDialog, setOpenGroupChatDialog] = useState(false);
  const [openBroadcastDialog, setOpenBroadcastDialog] = useState(false);
  const showBroadcast = canBroadcastMessage();

  // SEARCH USERS
  const [pageCountForGetUser, setPageCountForUser] = React.useState(1);
  const [dropdownSearchForUser, setDropdownSearchForUser] = React.useState("");
  const [dropdownOptionsForUser, setDropdownOptionsForUser] =
    React.useState<any>([]);
  const [selectedValueForUser, setSelectedValueForUser] =
    React.useState<any>(null);
  const [resetFlagForUser, setResetFlagForUser] = React.useState(false);

  const [timer, setTimer] = React.useState<NodeJS.Timeout | null>(null);

  //GET USERS SEARCH START:   LAZY LOAD USERS
  // **************************************************************
  React.useEffect(() => {
    if (!resetFlagForUser) {
      if (dropdownSearchForUser && dropdownSearchForUser.length > 0) {
        getDropdownSearchListForAssignTo(dropdownSearchForUser);
      } else {
        getDropdownListForAssignTo(pageCountForGetUser);
      }
    }
  }, [dropdownSearchForUser, pageCountForGetUser]);

  React.useEffect(() => {
    if (resetFlagForUser) {
      resetListForAssignTo();
    }
  }, [resetFlagForUser]);

  const resetListForAssignTo = () => {
    setSelectedValueForUser(null);
    setDropdownSearchForUser("");
    setPageCountForUser(1);
    getDropdownListForAssignTo(1, true);
  };

  // IF SEARCH VALUE  THEN WE ARE GIVEN SOME TIMER
  const handleSearchedValueChangeForAssignTo = (data: any) => {
    if (timer) {
      clearTimeout(timer); // Clear the previous timer
    }
    // Set a new timer with your desired delay (e.g., 500ms)
    const newTimer = setTimeout(() => {
      setDropdownSearchForUser(data);
    }, 500); // Adjust the delay as needed (in milliseconds)

    setTimer(newTimer); // Store the timer ID for cleanup
  };

  // GET DROPDOWN LIST
  const getDropdownListForAssignTo = async (pageCount: any, reset = false) => {
    dispatch(showLoader());
    try {
      const response = await getLazyLoadingApiResponse("user", pageCount, 8, {
        isForChat: true,
      });

      let usersList = response?.data?.users || {};
      const filteredUser = usersList?.filter(
        (data: any) => data?.id !== loginUserId
      );
      const mappedUserData = filteredUser?.map((data: any) => ({
        label: `${data?.firstName} ${data?.lastName}`,
        value: `${data?.id}`,
      }));

      if (mappedUserData && mappedUserData.length > 0) {
        if (reset) {
          setDropdownOptionsForUser(mappedUserData);
          setResetFlagForUser(false);
        } else if (
          !dropdownOptionsForUser?.some(
            (option: any) => option?.value === mappedUserData[0]?.value
          )
        ) {
          let options = dropdownOptionsForUser.concat(mappedUserData);
          setDropdownOptionsForUser(options);
        }
      }
    } catch (error) {
      console.log("error:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  // GET DROPDOWN SEARCH LIST
  const getDropdownSearchListForAssignTo = async (search: string) => {
    try {
      const response = await getLazyLoadingSearchApiResponse(
        "user",
        search,
        "name",
        { isForChat: true }
      );
      let usersList = response?.data?.users || {};
      const filteredUser = usersList?.filter(
        (data: any) => data?.id !== loginUserId
      );
      const mappedUserData = filteredUser?.map((data: any) => ({
        label: `${data?.firstName} ${data?.lastName}`,
        value: `${data?.id}`,
      }));
      if (mappedUserData?.length) {
        setDropdownOptionsForUser(mappedUserData);
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  // **************************************************************
  //GET USER  SEARCH LIST LOGIC END

  //HANDLER FOR CREATE GROUP
  const handlerForCreateGroup = (data: any) => {
    let patientIds = data?.userName?.map((item: any) => item?.value);
    const payload = {
      name: data?.groupName,
      users: patientIds,
    };
    dispatch(postGroupCreate(payload));
  };

  useEffect(() => {
    if (closeCreateGroup) {
      setOpenGroupChatDialog(false);
      dispatch(setCloseCreateGroup(false));
    }
  }, [closeCreateGroup]);

  useEffect(() => {
    if (closeBroadcast) {
      setOpenBroadcastDialog(false);
      dispatch(setCloseBroadcast(false));
    }
  }, [closeBroadcast]);

  useEffect(() => {
    const payload = {
      userId: loginUserId,
    };

    dispatch(getGroupCreated(payload));
  }, [closeCreateGroup]);

  return (
    <div>
      {/* SEARCH */}
      <div
        className="px-9 py-4"
        style={{
          borderBottom: "1px solid #D2D2D2",
          borderRight: "1px solid #D2D2D2",
        }}
      >
        <div className="flex gap-4">
          <div>
            <Button
              // startIcon={
              //   <img
              //     src={plusIcon}
              //     alt={"Create Group"}
              //     className="cursor-pointer w-[19px] h-[19px]"
              //   />
              // }
              label="Create Group"
              variant="contained"
              onClickCb={() => {
                // setDefaultIsEditData({ isEdit: false, data: {} });

                setOpenGroupChatDialog(true);
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
              }}
            ></Button>
          </div>
          {showBroadcast && (
            <div>
              <Button
                label="Broadcast"
                variant="outlined"
                onClickCb={() => {
                  setOpenBroadcastDialog(true);
                }}
                style={{
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  minWidth: "140px",
                }}
              ></Button>
            </div>
          )}
        </div>
        {selectedTabForUser === "Chats" && (
          <div className="mt-4">
            <EventEHRLazyDropdown
              // label="Search Users"
              placeholder="Search Users"
              noOptionText="No User Found"
              startIcon={
                <img
                  alt="search-icon"
                  src={searchIcon}
                  width={"18px"}
                  height={"18px"}
                />
              }
              clearSearch
              dropdownIcon
              dropdownOptions={dropdownOptionsForUser}
              dropdownSearch={dropdownSearchForUser}
              selectedValue={selectedValueForUser}
              setDropdownSearch={handleSearchedValueChangeForAssignTo}
              setPageCount={(data) => {
                setPageCountForUser(data);
              }}
              setResetFlag={(data) => {
                setResetFlagForUser(data);
              }}
              setSelectedValue={(data) => {
                if (data?.value) {
                  dispatch(
                    postConversationData({
                      userId: loginUserId,
                      connectedUserId: data?.value,
                    })
                  );
                }
                handleSetSelectedValue(data?.value);
                // setSelectedUserId(data?.value);
                setSelectedValueForUser(data);
              }}
            />
          </div>
        )}
        <div className="mt-4">
          <EventEHRToggleTabButton
            // customWidth="350px"
            defaultSelected={selectedTabForUser}
            tabs={["Chats", "Group Chats"]}
            onToggle={(value) => {
              setSelectedTab(value);
            }}
            variant="contained"
          />
        </div>
      </div>
      {selectedTabForUser === "Chats" ? (
        <div
          style={{
            height: "calc(100vh - 182px)",
            overflow: "auto",
            borderRight: "1px solid #D2D2D2",
          }}
        >
          {/* LIST */}
          {conversationList?.map((data: any, index: number) => (
            <List
              key={index}
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                p: 0,
                borderRight:
                  data?.id === selectedProviderMsg?.id
                    ? "1.5px solid #005596"
                    : "",
                background:
                  data?.id === selectedProviderMsg?.id ? "#E4F3FF" : "",
              }}
              className="cursor-pointer"
              onClick={() => onClickUser(data)}
            >
              <ListItem
                alignItems="flex-start"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  p: "16px 24px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  {/* IMAGE AVATAR */}
                  <EventEHRImageAvatar
                    image={""}
                    commonStyle={{
                      marginRight: "16px",
                      width: "35px",
                      height: "35px",
                      border: "2px solid #BCBCBC",
                      borderRadius: "50%",
                      overflow: "auto",
                    }}
                    customTextStyle={{
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    customImageStyle={{
                      borderRadius: "50%",
                    }}
                    labelText={`${data?.connectedUser?.firstName} ${data?.connectedUser?.lastName}`}
                  />
                  <Box>
                    <label className="text-base font-semibold text-[#393939] cursor-pointer">
                      {`${data?.connectedUser?.firstName} ${data?.connectedUser?.lastName}`}
                      &nbsp;&nbsp;
                      {/* {data?.connectedUser?.isOnline && ( */}
                      <FiberManualRecordIcon
                        className={
                          data?.connectedUser?.isOnline
                            ? `text-[green]`
                            : "text-[#b2b8b2]"
                        }
                        sx={{ height: "10px", width: "10px" }}
                      />
                      {/* )} */}
                    </label>

                    {data?.recentMessage && (
                      <div className="mt-1 text-xs	font-medium	text-[#727272]">
                        {data?.recentMessage || ""}
                      </div>
                    )}
                    {data?.time && (
                      <div
                        className="mt-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <span style={commonTimeStyle}>
                          <AccessTimeIcon
                            style={{
                              width: "13px",
                              height: "13px",
                              color: "#BCBCBC",
                            }}
                          />
                          Today
                        </span>
                        <span style={commonTimeStyle}>|</span>
                        <span style={commonTimeStyle}> {data?.time}</span>
                      </div>
                    )}
                  </Box>
                </Box>
                {/* FAVORITE OR NOT */}
                {data?.pin && (
                  <PushPinIcon
                    sx={{ color: "#005596" }}
                    onClick={() =>
                      handlePinMessage(
                        data?.pin,
                        data?.id,
                        data?.connectedUser?.id
                      )
                    }
                  />
                )}
              </ListItem>

              <Divider variant="fullWidth" component="li" />
            </List>
          ))}
        </div>
      ) : (
        <div
          style={{
            height: "calc(100vh - 182px)",
            overflow: "auto",
            borderRight: "1px solid #D2D2D2",
          }}
        >
          {/* LIST */}
          {groupCreated?.group?.map((data: any, index: number) => (
            <List
              key={index}
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                p: 0,
                borderRight:
                  data?.id === selectedProviderMsg?.id
                    ? "1.5px solid #005596"
                    : "",
                background:
                  data?.id === selectedProviderMsg?.id ? "#E4F3FF" : "",
              }}
              className="cursor-pointer"
              onClick={() => onClickGroup(data)}
            >
              <ListItem
                alignItems="flex-start"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "start",
                  p: "16px 24px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                  {/* IMAGE AVATAR */}
                  <EventEHRImageAvatar
                    image={""}
                    commonStyle={{
                      marginRight: "16px",
                      width: "35px",
                      height: "35px",
                      border: "2px solid #BCBCBC",
                      borderRadius: "50%",
                      overflow: "auto",
                    }}
                    customTextStyle={{
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    customImageStyle={{
                      borderRadius: "50%",
                    }}
                    labelText={`${data?.name}`}
                    // labelText={`${data?.connectedUser?.firstName} ${data?.connectedUser?.lastName}`}
                  />
                  <Box>
                    <label className="text-base font-semibold text-[#393939] cursor-pointer">
                      {/* {`${data?.connectedUser?.firstName} ${data?.connectedUser?.lastName}`} */}
                      {`${data?.name}`}
                      &nbsp;&nbsp;
                      {/* {data?.connectedUser?.isOnline && ( */}
                      <FiberManualRecordIcon
                        className={
                          data?.connectedUser?.isOnline
                            ? `text-[green]`
                            : "text-[#b2b8b2]"
                        }
                        sx={{ height: "10px", width: "10px" }}
                      />
                      {/* )} */}
                    </label>

                    {data?.recentMessage && (
                      <div className="mt-1 text-xs	font-medium	text-[#727272]">
                        {data?.recentMessage || ""}
                      </div>
                    )}
                    {data?.time && (
                      <div
                        className="mt-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <span style={commonTimeStyle}>
                          <AccessTimeIcon
                            style={{
                              width: "13px",
                              height: "13px",
                              color: "#BCBCBC",
                            }}
                          />
                          Today
                        </span>
                        <span style={commonTimeStyle}>|</span>
                        <span style={commonTimeStyle}> {data?.time}</span>
                      </div>
                    )}
                  </Box>
                </Box>
                {/* FAVORITE OR NOT */}
                {data?.pin && (
                  <PushPinIcon
                    sx={{ color: "#005596" }}
                    onClick={() =>
                      handlePinMessage(
                        data?.pin,
                        data?.id,
                        data?.connectedUser?.id
                      )
                    }
                  />
                )}
              </ListItem>

              <Divider variant="fullWidth" component="li" />
            </List>
          ))}
        </div>
      )}
      {openGroupChatDialog && (
        <GroupChatDialog
          //   isEdit={true} //for edit dialog
          dialogHeading={"Create Group Chat"}
          defaultDataForUser={groupCreated}
          isOpen={openGroupChatDialog}
          handleClose={() => setOpenGroupChatDialog(false)}
          handleData={handlerForCreateGroup}
        />
      )}
      {openBroadcastDialog && (
        <BroadcastMessageDialog
          isOpen={openBroadcastDialog}
          handleClose={() => setOpenBroadcastDialog(false)}
          handleSend={(content) => {
            dispatch(
              postBroadcast({
                senderId: loginUserId,
                content,
              })
            );
          }}
        />
      )}
    </div>
  );
};

export default UsersList;
